import CalenderLocalClock from './CalenderLocalClock';
import { useTemplate } from '../../hooks';
import CalenderLocalList from './CalenderLocalList';

const CalenderLocal = (props: any) => {
  const { tempoptions } = useTemplate();
  if (tempoptions?.calendarclock) {
    return <CalenderLocalClock {...props}></CalenderLocalClock>;
  }
  return <CalenderLocalList {...props}></CalenderLocalList>;
};

export default CalenderLocal;
